import { PipelineSourceSettingsPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/settings')({
  component: PipelineSourceSettingsPage,
});
